export const bindParams = (url, params) => {
	Object.keys(params).map((key) => {
		let replace_key = '_' + key.toUpperCase() + '_';
		url = url.replace(replace_key, params[key]);
	});
	return url;
};


export  const categoryItemMediator = (item) => {
	let matching_category = {};
	if(item.matching_id){
		matching_category = {
			id: item.matching_id,
			category_id: item.matching_category_id,
			title: item.matching_category_name,
		};
	}
	return {
		id: item.catalog_id,
		title: item.title,
		parent_id: item.catalog_parent_id,
		catalog_name: item.catalog_name,
		matching_category,
		count_products: +item.count_products
	};
};



// WEBPACK FOOTER //
// ./frontend/utils/api.js